<app-header></app-header>
<qnect-spinner></qnect-spinner>
<router-outlet></router-outlet>
<app-footer></app-footer>